export default "__VITE_ASSET__DUq2CVsl__"